import store from '../store/store.js'

const isAuthed = async () => {
  // check store first
  if (store.getters['authentication/isAuthenticated']) {
    return true
  }

  // if no store then fill it
  try {
    const activeAccountId = localStorage.getItem('activeAccountId')

    if (!activeAccountId) {
      return false
    }

    await store.dispatch('authentication/getUserAuth', activeAccountId)

    return true
  } catch (error) {
    return false
  }
}

const beforeEnterAuthedRoutes = async (to, from, next) => {
  if (await isAuthed()) {
    if (!store.getters['fund/balanceFetched']) {
      await store.dispatch('fund/getBalance')
    }
    next()
  } else {
    next('/login')
  }
}

const beforeEnterPublicRoutes = async (to, from, next) => {
  if (!await isAuthed()) {
    next()
  } else {
    next('/')
  }
}

export {
  beforeEnterAuthedRoutes,
  beforeEnterPublicRoutes
}
